module.exports = __webpack_public_path__ + "img/return-icon.f1b215b7.svg";